/* eslint-disable camelcase */

import {
  PAYPAL_PREAUTH,
  PAYPAL_PAYORDER,
  PAYPAL_PAYCONFIRM,
  PAYPAL_PREAUTHCONFIRM
} from "../apis/payment";

export default {
  methods: {
    // paypal 支付
    paypalPay(payMode, payType = "YJ") {
      payMode.payCode = this.cabinetID || this.mificode || this.qrcode;
      switch (payType) {
        case "CZ":
          this.payRechargePaypal(payMode);
          break;
        case "FK":
          this.payOrderWithPaypal(payMode);
          break;
        default:
          this.preauthWithPaypal(payMode);
      }
    },
    /**
     * 预授权支付
     * @param {*} payMode payCode
     */
    async preauthWithPaypal(payMode = {}) {
      const query = {};
      this.$loading(true);
      const url = `${PAYPAL_PREAUTH}${payMode.payCode}?paymentId=${payMode.pId}`;
      let headers = {};
      await this.$Request("post", url, query, headers)
        .then(({ data = {}, code }) => {
          if (code === 0 && data && data.approve) {
            this.goPalPayApprove(data.approve, data.tradeNo, payMode);
          }
        })
        .catch(err => {
          console.warn(" onCreditcard ~ err:", err);
          this.$confirm({
            title: this.i18nPay.msg_fail_title,
            content: this.i18nPay.msg_fail_order,
            confirmText: this.i18nPay.msg_fail_retry,
            cancelText: this.i18nPay.msg_fail_cancel
          }).then(() => {
            this.preauthWithPaypal(payMode);
          });
        });
    },
    /**
     * 充值支付
     * @param {*} payMode
     */
    payRechargePaypal(payMode) {},
    /**
     * 订单支付
     * @param {*} payMode
     */
    async payOrderWithPaypal(payMode) {
      const query = {
        outTradeNo: payMode.outTradNo,
        paymentId: payMode.pId || "",
        couponNo: payMode.couponNo || "",
        userCardId: payMode.userCardId || ""
      };
      this.$loading(true);
      let headers = {};
      await this.$Request("post", PAYPAL_PAYORDER, query, headers)
        .then(({ data = {}, code }) => {
          if (code === 0 && data && data.checkOutUrl) {
            this.goPalPayApprove(data.checkOutUrl, data.paymentId, payMode);
          }
        })
        .catch(err => {
          console.warn("payOrderWithPaypal ~ err:", err);
          this.$confirm({
            title: this.i18nPay.msg_fail_title,
            content: this.i18nPay.msg_fail_order,
            confirmText: this.i18nPay.msg_fail_retry,
            cancelText: this.i18nPay.msg_fail_cancel
          }).then(() => {
            this.payOrderWithPaypal(payMode);
          });
        });
    },
    // 跳转到 paypal 支付页面
    goPalPayApprove(path, tradeNo, payMode) {
      let pay_trade_no = sessionStorage.getItem("pay_trade_no");
      if (pay_trade_no !== tradeNo) {
        sessionStorage.setItem("pay_trade_no", tradeNo);
        sessionStorage.setItem("pay_payment_id", payMode.pId);
        window.location.href = path;
      }
    },
    // 支付确认
    async palPayConfirm(param, callback) {
      let query = {
        outTradeNo: "",
        tradeNo: param.token
      };
      let url = PAYPAL_PAYCONFIRM;
      let confirm_pay_type = "order";
      if (param.paymentId) {
        confirm_pay_type = "preauth";
        query = new URLSearchParams(query).toString();
        url = `${PAYPAL_PREAUTHCONFIRM}?${query}`;
        query = {
          token: param.token,
          PayerID: param.PayerID,
          paymentId: param.paymentId
        };
      }
      let headers = {};
      await this.$Request("get", url, query, headers)
        .then(resp => {
          console.log(" palPayConfirm ~ resp:", resp);
          resp.confirm_pay_type = confirm_pay_type;
          callback && callback(resp);
        })
        .catch(err => {
          console.warn("palPayConfirm ~ err:", err);
          this.$confirm({
            title: this.i18nPay.msg_fail_title,
            content: this.i18nPay.msg_fail_order,
            confirmText: this.i18nPay.msg_fail_retry,
            cancelText: this.i18nPay.msg_fail_cancel
          }).then(() => {
            this.palPayConfirm(param, callback);
          });
        });
    }
  }
};
